import React, { useState } from "react";
import { motion } from "framer-motion";
import {
  Briefcase, BarChart3, FileCheck2, Users, Plane, Wallet, ShieldCheck, Building2,
  FileText, GraduationCap, Stethoscope, HardHat, Flame, Factory, Wrench,
  ConciergeBell, Truck, Sprout, ChevronDown, Globe2,
} from "lucide-react";

export const ICONS = {
  Briefcase, BarChart3, FileCheck2, Users, Plane, Wallet, ShieldCheck, Building2,
  FileText, GraduationCap, Stethoscope, HardHat, Flame, Factory, Wrench,
  ConciergeBell, Truck, Sprout, Globe2,
};

export const Icon = ({ name, className }) => {
  const C = ICONS[name] || Globe2;
  return <C className={className} />;
};

export function Eyebrow({ children }) {
  return (
    <div className="text-xs font-semibold uppercase tracking-[0.18em] text-[#0088FF]">{children}</div>
  );
}

export function PageHero({ eyebrow, title, subtitle, image }) {
  return (
    <section className="relative brand-gradient-navy overflow-hidden">
      <div className="absolute inset-0 brand-dotgrid opacity-50" />
      {image && (
        <>
          <img src={image} alt="" className="absolute inset-0 w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0A192F] via-[#0A192F]/90 to-[#0A192F]/40" />
        </>
      )}
      <div className="relative max-w-7xl mx-auto px-6 py-20 lg:py-24">
        {eyebrow && <div className="text-xs font-semibold uppercase tracking-[0.18em] text-sky-300 mb-3">{eyebrow}</div>}
        <motion.h1 initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white leading-[1.05] tracking-tight max-w-4xl">
          {title}
        </motion.h1>
        {subtitle && <p className="mt-5 text-base md:text-lg text-slate-300 max-w-2xl leading-relaxed">{subtitle}</p>}
      </div>
    </section>
  );
}

export function FAQ({ items }) {
  const [open, setOpen] = useState(0);
  return (
    <div className="divide-y divide-slate-200 rounded-2xl border border-slate-200 bg-white overflow-hidden" data-testid="faq-list">
      {items.map((it, i) => {
        const isOpen = open === i;
        return (
          <div key={it.q}>
            <button
              data-testid={`faq-q-${i}`}
              onClick={() => setOpen(isOpen ? -1 : i)}
              className="w-full flex items-center justify-between gap-4 text-left px-6 py-5 hover:bg-slate-50 transition-colors"
            >
              <span className="font-semibold text-[#0A192F]">{it.q}</span>
              <ChevronDown className={`h-5 w-5 text-[#0088FF] shrink-0 transition-transform duration-300 ${isOpen ? "rotate-180" : ""}`} />
            </button>
            <div className={`grid transition-all duration-300 ${isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`}>
              <div className="overflow-hidden">
                <p className="px-6 pb-5 text-slate-600 leading-relaxed">{it.a}</p>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
}
